import { render, staticRenderFns } from "./VendorDetails.vue?vue&type=template&id=f2fe9b00&scoped=true&"
import script from "./VendorDetails.vue?vue&type=script&lang=js&"
export * from "./VendorDetails.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VendorDetails.vue?vue&type=style&index=1&id=f2fe9b00&scoped=true&lang=css&"
import style2 from "./VendorDetails.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fe9b00",
  null
  
)

export default component.exports